import React from 'react';
import PropTypes from 'prop-types';
import OutcomesHeader from 'SportsbookCommon/bet_boost/outcomes_header';

const CardHeader = ({ description, eventId }) => (
  <>
    <div className="bvs-header market-view__centered-event-title">{ description }</div>
    <OutcomesHeader eventId={eventId} />
  </>
);

CardHeader.propTypes = {
  description: PropTypes.string.isRequired,
  eventId: PropTypes.number.isRequired,
};

export default CardHeader;
